import React, { useContext } from "react";
import { SidebarContext } from "../context/Sidebar";

export default function MainLayout({ children }) {
    const { sidebar } = useContext(SidebarContext);
    return <main className={`mc-main h-[calc(100vh_-_90px)] ${sidebar && "active"}`}>{ children }</main>
}